export default __webpack_public_path__ + "static/media/delivered.aa98ebbf.svg";